<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
        class="formData"
      >
        <div>
          <el-form-item label="角色名称" prop="Name">
            <el-input v-model="formData.Name"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="备注说明">
            <el-input
              type="textarea"
              maxlength="140"
              show-word-limit
              v-model="formData.Remark"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancel()">关闭</el-button>
        <el-button class="btn-primary" @click="submitRoleForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["roleId"],
  name: "",
  data() {
    return {
      formData: {
        UnionId: this.$util.getLocalStorage("currentUnion"),
        RoleId: "",
        Name: "",
        Remark: "",
      },
      rules: {
        Name: [
          {
            required: true,
            message: "角色名称必填",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.roleId) {
      this.formData.RoleId = this.roleId;
      this.getRoleInfo();
    }
  },
  methods: {
    getRoleInfo() {
      let url = "/api/EntpUnions/GetUnionRoleById";
      this.$util
        .axiosGet({
          url: url,
          data: {
            UnionId: this.formData.UnionId,
            RoleId: this.formData.RoleId,
          },
        })
        .then((res) => {
          if (res.data) {
            this.formData.Name = res.data.Name;
            this.formData.Remark = res.data.Remark;
          }
        })
        .catch(() => {});
    },
    // 提交表单
    submitRoleForm() {
      let that = this;
      that.$refs.formData.validate((valid) => {
        if (valid) {
          let url = "/api/EntpUnions/SubmitRoleData";
          that.$util
            .axiosPost({
              url: url,
              data: that.formData,
            })
            .then(() => {
              that.$util.successMsg("成功创建角色");
              that.$emit("closeDialog", true);
            })
            .catch(() => {});
        } else {
          this.$util.errorMsg("校验不通过");
          return false;
        }
      });
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
